import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDocumentTitle } from '@/hooks';
import { SCHEDULE_ROUTES } from '../api';
import { AppointmentDialog } from '../components/appointment-dialog';

/**
 * Link direto para um agendamento. Abre o mesmo wizard da agenda em tela
 * cheia; fechar volta para a tela de onde se veio - a fila de atendimentos
 * manda a origem no `state`, e sem ela a agenda continua sendo o destino.
 */
export function AppointmentFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  useDocumentTitle(id ? 'Agendamento' : 'Novo agendamento');

  const state = location.state as { from?: string; reschedule?: boolean } | null;
  const origem = state?.from ?? SCHEDULE_ROUTES.AGENDA;

  return (
    <AppointmentDialog id={id} reschedule={state?.reschedule} onClose={() => navigate(origem)} />
  );
}
